// <img onError> handler that steps through a fallback chain and then STOPS.
//
// The old pattern `onError={e => (e.target.src = fallback)}` re-fires forever
// when the fallback itself is broken: the browser reloads it, it errors again,
// and the card flickers between blank and the broken-image box. The live
// backend's default item image (GET_IMAGES → item_image) is exactly that — an
// empty 4-byte JPEG — so every card without its own image looped.
//
// `e.target.onerror = null` does NOT stop it under React: React binds img
// `error` with addEventListener, not the onerror property.
//
// Pass the chain best-first and end with a bundled asset, e.g.
//   onError={imgFallback(defaultImgs?.item_image, dr_2)}
// The step is derived from the current src (no stored state), so the chain is
// walked once per src and a re-rendered/recycled <img> starts over cleanly.

const toAbsolute = (url) => {
  try {
    return new URL(url, document.baseURI).href;
  } catch {
    return url;
  }
};

export const imgFallback = (...fallbacks) => (e) => {
  const img = e.currentTarget;
  const chain = fallbacks.filter(Boolean).map(toAbsolute);
  const current = img.src;
  // If the failing src is already one of the fallbacks, continue after it;
  // otherwise (it was the item's own image) start at the top of the chain.
  const at = chain.lastIndexOf(current);
  const next = chain.slice(at + 1).find((url) => url !== current);
  if (next) img.src = next;
};
